import { useMemo } from 'react';

import { JOB_STATUSES } from '@helpers';
import { ColorFunction } from '@styles/colors/types';
import { StatusBadgeConfig } from '@components/common/StatusBadge/types';

const useJobStatusBadgeConfig = ({ status, C }: { status: string; C: ColorFunction }): StatusBadgeConfig => {
  const jobConfig = useMemo(() => {
    return {
      running: {
        condition: status === JOB_STATUSES.RUNNING,
        state: {
          styles: {
            backgroundColor: C('ProdJobBatch/Light/Running'),
            color: C('Label/Light/AlwaysLight Primary'),
            boxStylesOverride: { height: 'auto' },
          },
          icon: 'runningMan',
          width: 10,
          height: 18,
        },
      },
      paused: {
        condition: status === JOB_STATUSES.PAUSED,
        state: {
          styles: {
            backgroundColor: C('ProdJobBatch/Light/Paused'),
            color: C('Label/Light/AlwaysLight Primary'),
            boxStylesOverride: { paddingHorizontal: 9, paddingVertical: 7, height: 'auto' },
          },
          icon: 'pause',
          width: 6,
          height: 10,
        },
      },
      finished: {
        condition: status === JOB_STATUSES.FINISHED,
        state: {
          styles: { backgroundColor: C('ProdJobBatch/Light/Finished'), color: C('Label/Light/AlwaysLight Primary') },
          icon: 'finishFlag',
          width: 10,
          height: 18,
        },
      },
      skipped: {
        condition: status === JOB_STATUSES.SKIPPED,
        state: {
          styles: { backgroundColor: C('Status/Light/Not Productive'), color: C('Label/Light/AlwaysLight Primary') },
          icon: 'skipped',
          width: 10,
          height: 18,
        },
      },
      // Not Started status - no icon shown per Figma design
      // notStarted: {
      //   condition: status === JOB_STATUSES.NOT_STARTED,
      //   state: {
      //     styles: {
      //       backgroundColor: 'transparent',
      //       color: C('Status/Light/Not Productive'),
      //       boxStylesOverride: { paddingHorizontal: 0, paddingVertical: 0 },
      //     },
      //     icon: 'dotsClock',
      //     width: 30,
      //     height: 38,
      //   },
      // },
      start: {
        condition: status === JOB_STATUSES.START,
        state: {
          styles: { backgroundColor: C('Status/Light/Active'), color: C('Label/Light/AlwaysLight Primary') },
          icon: 'play',
          width: 10,
          height: 18,
        },
      },
    };
  }, [status, C]);

  return jobConfig;
};

export default useJobStatusBadgeConfig;
